import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React, { useContext, useState } from "react";
import { AppContext } from "../context/AppContext";

export const AppSelectDropdown = (props) => {
  const { appSelectHandler, defaultAPIKey } = props;
  const { selectedAPIKey, setSelectedAPIKey } = useContext(AppContext);
  const [qrCode, setQrCode] = useState("");
  const [validationResult, setValidationResult] = useState(null);
  const [expiryTime, setExpiryTime] = useState(null);
  const [refreshQrCode, setRefreshQrCode] = useState(false);

  const handleChange = (event) => {
    setRefreshQrCode(false);
    setExpiryTime(null);
    setValidationResult(null);
    setSelectedAPIKey(event.target.value);
    if (appSelectHandler) appSelectHandler(event.target.value);
  };

  return (
    <FormControl variant="standard" sx={{ m: 0, width: "100%" }}>
      <InputLabel id="account-id-label">Select App:</InputLabel>
      <Select
        labelId="account-id-label"
        value={selectedAPIKey}
        onChange={handleChange}
        label="Select App:"
        sx={{
          textAlign: "left",
        }}
      >
        <MenuItem value="71944e94-ef5c-4215-b2f9-789dca622c5b.2551d4ed-a61d-4b4b-a666-a9f4b018a126">
          BN1
        </MenuItem>
        <MenuItem value="f8af0f33-8030-42d1-86d8-dcdb46a269ad.14e39da8-5cf8-48fb-a3f0-55c71fb67722">
          Nevada
        </MenuItem>
        <MenuItem value="ffffffff-d305-416a-9fd1-a44ba02e3b56.3fe8d9f0-8535-4118-95c7-6c740cb92737">
          Rio De Janeiro
        </MenuItem>
      </Select>
    </FormControl>
  );
};
